<template>
  <div class="contract-attachment" style="min-height: 400px">
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id">
      <el-table-column prop="fileName" label="文件名称" align="left" fixed="left">
        <template v-slot="{row}">
          <el-button type="text" @click="openContract(row.fileToken)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left">
        <template v-slot="{row}">
          <el-popover v-model="row.removeVisible" width="160">
            <p style="line-height: 30px">
              确认删除该文件吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="row.removeVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="removeFile(row)">
                确定
              </el-button>
            </div>
            <el-button v-if="row.createBy === $store.state.user.userId" slot="reference" type="text" style="color: #F56C6C;">
              删除
            </el-button>
          </el-popover>
          <el-button type="text" style="margin-left: 10px" @click="downOneFile(row.fileToken)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { downloadUrlFile } from '@/libs/util.js';
import {
  getAttachmentListByContractId,
  attachmentGetToken,
  getUrlByFileID,
  deleteByContractIdAndAttachmentId
} from '@/API/index';
export default {
  props: {
    contractNum: {
      type: Number,
      default: 0
    }
  },

  mounted () {
    this.searchFiles();
    this.initToken();
  },

  data () {
    return {
      tableData: [],
      tableLoading: false,
      token: '',
      uploadUrl: '',
      downFileUrl: ''
    };
  },

  methods: {
    searchFiles () {
      this.tableLoading = true;
      getAttachmentListByContractId(this.contractNum).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    // 查看合同附件详情
    openContract (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    // 下载合同附件
    downOneFile (id) {
      let url = this.downFileUrl + `/${id}?Token=${this.token}`;
      downloadUrlFile(url || '');
    },

    removeFile (row) {
      this.tableLoading = true;
      deleteByContractIdAndAttachmentId({
        contractId: row.contractId,
        attachmentId: row.id
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.searchFiles();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    }
  }
};
</script>
